module.exports = __webpack_public_path__ + "static/img/ic_certificate_d.067b1989.png";